import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/core';
import { Button } from '@material-ui/core';

import {RecordDocumentService} from '@sdk-point/talisis'; // Comment or remove this line if the module is not needed
import { create } from 'canvas-confetti';

const RecordDocumentServiceSDK = new RecordDocumentService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY); // Comment or remove this line if unused

const useStyles = makeStyles((theme) => ({
    root: {
        '& .step': {
            minWidth: 70
        }
    },
    list: {
        paddingLeft: 20,
        ...theme.typography.body2,
        color: theme.palette.colors.blue[300],
        display: 'grid',
        gridGap: 8
    }
}));

const COMPROBANTE_ENVIO = process.env.REACT_APP_ENV === 'dev' ? 127 : 94; // ID dinámico basado en el ambiente

const ShippingDetailV2 = ({learningStyle, templateId, onSuccess, onClosed}) => {
    const classes = useStyles();
    const [showErrorAlert, setShowErrorAlert] = React.useState(false); // State for alert visibility
    const [filePendingSend, setFilePendingSend] = React.useState(false); // State for file pending send

    const handleClickAddDocument = async (newDocumentId) => {
        try {
            const body = {
                typeId: 1,
                templateId: templateId, 
                documentId: COMPROBANTE_ENVIO
            }
            
            const createDocumentReponse = await RecordDocumentServiceSDK.createAdditionalDocumentToUser(body);

            if (!createDocumentReponse.success) {
                const message = createDocumentReponse.message;

                if (message == 'Ya contaba con la documentación asignada.') {
                    setShowErrorAlert(true);
                    setFilePendingSend(true);
                    
                } else {
                    setShowErrorAlert(true);
                    setFilePendingSend(false);
                }

            } else {
                onClosed();
                onSuccess();
            }
        }
        catch (error) {
            console.error('Error:', error); // Registra el error para depuración
            setShowErrorAlert(true); // Muestra una alerta en caso de excepción
        }
    }

    return (
        <>
            {showErrorAlert && ( // Conditionally render the alert
                <Alert 
                    onClose={() => setShowErrorAlert(false)} 
                    variant="filled" 
                    severity="warning" 
                    color="info" 
                    icon={<i className="ri-alert-fill text-error-300"></i>} 
                    className="bg-yellow-100 text-gray-900"
                >
                    
                    {/* En caso de que ya tenga un comprobante activo y pendiente de envio */}
                    {filePendingSend &&
                        <Typography component="div" variant="body2" className="semi-bold">
                            Ya cuentas con un comprobante de envío. Favor de enviar el comprobante pendiente.
                        </Typography>
                    }
                    {/* En caso de que se tenga un error en el backend */}
                    {!filePendingSend &&
                        <>
                            <Typography component="div" variant="body2" className="semi-bold">
                                Ha ocurrido un error.
                            </Typography>   
                            <Typography component="p" variant="body2" className="mt-2 text-gray-500">
                                Error en el sistema, favor de intentar más tarde.
                            </Typography>
                        </>
                    }
                    
                </Alert>
            )}
            {
                learningStyle != 1 && !showErrorAlert &&
                <Box className={classes.root} id="shipping-detail-root" display="flex" flexDirection="column" gridGap={24}>
                    <Box>
                        <Typography variant='subtitle2' fontSize="16px" className='text-gray-100'>Tienes dos opciones para entregar los documentos físicos:</Typography>
                    </Box>
                    <Box display='flex' flexDirection='row' gridGap={16} pb={3}>
                        <Box>
                            <Typography variant='subtitle2' className='text-violet-300 step'>Opción 1</Typography>
                        </Box>
                        <Box display='flex' gridGap={24} flexDirection='column'>
                            <Typography variant='subtitle2' className='text-gray-100'>Entrega en el campus más cercano.</Typography>
                            <Typography variant='body1' className='text-gray-100'>
                                Acude al campus más cercano con tus documentos; nuestro equipo te guiará durante el proceso. Al finalizar, recibirás un acuse de recibo consérvalo para cualquier aclaración.
                            </Typography>
                        </Box>
                    </Box>
                    <Box display='flex' flexDirection='row' gridGap={16} pb={3}>
                        <Box>
                            <Typography variant='subtitle2' className='text-violet-300 step'>Opción 2</Typography>
                        </Box>
                        <Box display='flex' gridGap={''} flexDirection='column'>
                            <Typography variant='subtitle2' className='text-gray-100'>Envía tus documentos por paquetería o entrégalos en persona en nuestras oficinas de Ciudad de México.</Typography>
                            <Typography variant='body1' className='text-gray-100'>
                                <ul>
                                    <li>
                                        Si decides enviarlos por paquetería te recomendamos usar DHL para mayor seguridad.
                                    </li>
                                    <li>
                                        Evita enviar por Correos de México, ya que puede haber demoras.
                                    </li>
                                    <li>
                                        Asegúrate de dirigir el envío a:
                                    </li>
                                </ul>
                            </Typography>
                            <Typography
                                variant='subtitle2'
                                className='text-gray-100'
                                style={{ fontWeight: 700, marginBottom: '0px' }}
                            >
                                Destinatario:
                            </Typography>
                            <Typography variant='body1' className='text-gray-100'>
                                José de Jesús Flores González
                            </Typography>
                            <Typography
                                variant='subtitle2'
                                className='text-gray-100'
                                style={{ fontWeight: 700, marginBottom: '0px', marginTop: '24px' }}
                            >
                                Dirección:
                            </Typography>
                            <Typography variant='body1' className='text-gray-100'>
                                Av. Paseo de la Reforma #250<br />
                                Colonia Juárez, Alcaldía Cuauhtémoc<br />
                                C.P. 06600, Ciudad de México<br />
                                Edificio Capital Reforma, Torre A, Piso 25<br />
                                Empresa: Talisis
                            </Typography>
                        </Box>
                    </Box>
                    <Box display='flex' flexDirection='column' alignItems={'center'}>
                        <Box maxWidth={400}>
                            <Button variant='contained' color='primary' fullWidth onClick={handleClickAddDocument}>Elegir Opción 2</Button>
                        </Box>
                    </Box>
                    <Box display='flex' flexDirection='column' gridGap={16} pb={3}>
                        <Typography variant='body1' className='text-gray-100'>

                            <span className='text-orange-300'>Importante:</span> Antes de enviar o entregar, revisa que los documentos estén completos y en buen estado.

                        </Typography>
                    </Box>
                </Box>
            }

            {
                learningStyle === 1 && !showErrorAlert &&
                <Typography variant='subtitle2' className='text-gray-100' style={{ fontWeight: 700 }}>Asegúrate de que tus documentos estén completos y en buen estado. Entrégalos directamente en el departamento Escolar de tu campus; nuestro equipo te guiará durante el proceso.</Typography>
            }
        </>
    );
};

export default ShippingDetailV2;